import { useEffect } from 'react';
import type { Blot } from '../../types';

// Only add classes to blots defined highlight styles.
const allowedBlotNames = new Set([
  'attachment',
  'image',
  'embed',
  'card',
  'video',
  'iframe',
  'file',
]);
const highlightedClassName = 'ql-highlighted';

const highlightedCountMap = new WeakMap<Node, number>();

const useBlotHighlightedClass = (blot?: Blot | null) => {
  useEffect(() => {
    if (!blot || !allowedBlotNames.has(blot.statics.blotName)) {
      return undefined;
    }
    const { domNode } = blot;

    if (highlightedCountMap.has(domNode)) {
      const count = highlightedCountMap.get(domNode) ?? 0;
      highlightedCountMap.set(domNode, count + 1);
    } else {
      (domNode as Element).classList.add(highlightedClassName);
      highlightedCountMap.set(domNode, 1);
    }
    return () => {
      const remainingCount = (highlightedCountMap.get(domNode) ?? 0) - 1;
      if (remainingCount > 0) {
        highlightedCountMap.set(domNode, remainingCount);
      } else {
        highlightedCountMap.delete(domNode);
        (domNode as Element).classList.remove(highlightedClassName);
      }
    };
  }, [blot]);
};

export default useBlotHighlightedClass;
